var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Badge, Button, FlexBox, Icon, Spinner, Tooltip, } from '@dixa/lib-shared-habla';
import { sizes, typography } from '@dixa/lib-shared-tokens';
import { useCallback } from 'react';
import { appActions } from 'app/app.actions';
import { analytics } from 'app/utils/segment';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
/** Represents the conversations bulk toolbar component. */
// TODO: [TEAMS-8303] handle potential rejected async status
export const ConversationsBulkToolbar = ({ className, location, asyncStatus, selectedConversationIds, eligibleBulkConversationIds, totalFilteredConversations, onSelectAll, onClearAll, }) => {
    const dispatch = useAppDispatch();
    const isBulkUpdateDisabled = asyncStatus === 'rejected' ||
        selectedConversationIds.length > eligibleBulkConversationIds.length ||
        selectedConversationIds.length === 0;
    /** Handles clearing all conversations. */
    const handleClearAll = useCallback(() => {
        onClearAll === null || onClearAll === void 0 ? void 0 : onClearAll();
        analytics.conversationsClearAllClicked();
    }, [onClearAll]);
    /** Handles selecting all eligible conversations. */
    const handleSelectAll = useCallback(() => {
        onSelectAll();
        if (location === 'conversations') {
            analytics.conversationsSelectAllClicked();
        }
    }, [location, onSelectAll]);
    /** Handles the bulk update. */
    const handleBulkUpdate = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        analytics.conversationsBulkActionsClicked({
            location,
            modalVersion: '2',
        });
        const { isConfirmed } = yield dispatch(appActions.showModal({
            modal: {
                type: 'app:conversationsBulk',
                arg: {
                    conversationIds: selectedConversationIds,
                    location: 'conversations',
                },
            },
        }));
        if (isConfirmed) {
            onClearAll === null || onClearAll === void 0 ? void 0 : onClearAll();
        }
    }), [dispatch, location, onClearAll, selectedConversationIds]);
    const isSelectionOverTheLimit = totalFilteredConversations > eligibleBulkConversationIds.length;
    const label = isSelectionOverTheLimit
        ? `Select first ${eligibleBulkConversationIds.length}`
        : `Select all ${eligibleBulkConversationIds.length}`;
    const tooltip = isSelectionOverTheLimit
        ? `Selects first ${eligibleBulkConversationIds.length} filtered conversations for bulk update`
        : 'Selects all filtered conversations for bulk update';
    return (_jsxs(FlexBox, Object.assign({ className: className, alignItems: "center", gap: sizes.spacer['200'] }, { children: [(asyncStatus === 'pending' || asyncStatus === 'uninitialized') && (_jsx(Spinner, { size: 16 })), asyncStatus === 'fulfilled' &&
                eligibleBulkConversationIds.length > 0 && (_jsx(Tooltip, Object.assign({ dark: true, content: tooltip }, { children: _jsx(Button, Object.assign({ variant: "tertiary", onClick: handleSelectAll }, { children: label })) }))), asyncStatus === 'rejected' && (_jsx(Tooltip, Object.assign({ dark: true, content: "Something went wrong, try clearing the selection and start again.", wrap: "div", wrapProps: {
                    style: {
                        display: 'flex',
                        color: typography.color.error,
                    },
                } }, { children: _jsx(Icon, { size: 16, name: "exclamation" }) }))), onClearAll && (_jsx(Button, Object.assign({ variant: "tertiary", onClick: handleClearAll }, { children: "Clear all" }))), _jsx(Button, Object.assign({ variant: "primary", disabled: isBulkUpdateDisabled, slotEnd: _jsx(Badge, Object.assign({ variant: "secondary", size: "small" }, { children: selectedConversationIds.length })), onClick: handleBulkUpdate }, { children: "Bulk update" }))] })));
};
